import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Feather from 'react-feather';
import { Label } from 'reactstrap';
// import ReactTooltip from 'react-tooltip';
import { Popover, ArrowContainer } from 'react-tiny-popover';

import { matchPath, Link } from 'react-router-dom';

import NavBadge from './NavBadge';

const NavSingleItemWithPendingSetup = ({ setupDone, isActive, item, count, branding, shadeColor, location, isCompanyPerksTab }) => {
  const Icon = item.icon && Feather[item.icon] ? Feather[item.icon] : null;

  const [hoverActive, setHoverActive] = React.useState(false);
  /*
  let isOpen = true;
  const setIsOpen = (val) => {
    console.log('setIsOpen', val);
    isOpen = val;
  } */

  const [isOpen, setIsOpen] = useState(true);

  if (item.external) {
    const rel = item.target && item.target === '_blank' ? 'noopener noreferrer' : null;

    return (
      <li
        className="nav-item nav-item-withCounter"
        onMouseEnter={() => setHoverActive(true)}
        onMouseLeave={() => setHoverActive(false)}
      >
        <a href={item.url} target={item.target} rel={rel}>
          {item.icon && Icon && <Icon className="side-nav-icon" />}
          <span className="nav-item-label">{item.name}</span>
          {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
        </a>
      </li>
    );
  } else {
    // Force relative URLs to start with a slash
    const url = item.url.charAt(0) === '/' ? item.url : `/${item.url}`;

    let isActiveLink = false;
    if (location === item.url) {
      isActiveLink = true;
    }

    console.log('isActive isActiveLink hoverActive', isActive, isActiveLink, hoverActive, isOpen);

    let bgColor2 = '#0b1628';

    if (branding.sidebarPrimaryColor) {
      bgColor2 = branding.sidebarPrimaryColor;
    }

    if (isCompanyPerksTab && branding.perksBackgroundColor) {
      bgColor2 = branding.perksBackgroundColor;
    }

    let bgColor = '#ff6a00';

    let isActive2 = true;

    return (
      <>
        <Popover
          positions={['right']}
          padding={10}
          isOpen={isOpen}
          onClick={() => setIsOpen(false)}
          content={({ position, childRect, popoverRect }) => (
            <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
              position={position}
              childRect={childRect}
              popoverRect={popoverRect}
              arrowColor={'#14c2ff'}
              arrowSize={6}
              arrowStyle={{ opacity: 0.9 }}
            >
              <div
                style={{
                  backgroundColor: '#14c2ff',
                  color: '#FFF',
                  opacity: 0.9,
                  padding: 3,
                  paddingTop: 8,
                  paddingRight: 15,
                  paddingLeft: 15,
                  borderRadius: 2,
                  fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
                  fontSize: 15,
                }}
                onClick={() => setIsOpen(false)}
              >
                <div style={{ display: 'inline-block', paddingRight: 3 }}>Complete for setup - 1 min guide in </div>
                <Link to="/setup-help" style={{ display: 'inline-block' }}>
                  <Label style={{ cursor: 'pointer', color: '#fff', textDecoration: 'underline', fontWeight: 'bold' }}> Setup Help </Label>
                </Link>
                <div style={{ cursor: 'pointer', fontWeight: 900, display: 'inline-block', color: '#FFF' }}>{'\uD83D\uDDD9'}</div>
              </div>
            </ArrowContainer>
          )}
        >
          
          <li className={`nav-item nav-item-withCounter nav-item-pending-setup ${isActive ? 'box' : ''}`} style={{ backgroundColor: bgColor2, lineHeight: '38px', boxShadow: 'none' }}>
            <NavLink
              to={url}
              style={{
                color: (isCompanyPerksTab && branding.perksTextColor) ? branding.perksTextColor : branding.sidebarTextColor,
                background: (isActive || isActiveLink || hoverActive) ? shadeColor(bgColor, 20) : bgColor,
                borderRadius: 16,
                //border: isActive ? "3px solid #ff6a00" : '0',
              }}
              activeClassName="active"
              onMouseEnter={() => setHoverActive(true)}
              onMouseLeave={() => setHoverActive(false)}
            >
              {item.icon && Icon && <Icon className="side-nav-icon" />}
              <span className="nav-item-label">{item.name}</span>
              {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
            </NavLink>
            </li>
        </Popover>
      </>
    );
  }
};

export default NavSingleItemWithPendingSetup;
